import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //缓存的全局使用的数据
        email: null,
        // userInfo: null
    },
    mutations: {
        //要大写
        RECORD_EMAIL: (state, email) => {
            state.email = email
        },
        // CHANGEUSER_INFO: (state, info) => {
        //     state.userInfo = info
        // }
    },
    actions: {
        //异步的操作数据写这里
        // async changeUser ({state, commit}, id) {
        //     const { data } = await getUserInfo({ id })
        //     localStorage.userInfo = data.user
        //     commit('changeUserInfo', data.user)
        // }
    },
    getters: {
        email: state => state.email || localStorage.email
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js